import { render, staticRenderFns } from "./AgriculturalObjectiveTabComponent.vue?vue&type=template&id=78e5d3f4&scoped=true"
import script from "./AgriculturalObjectiveTabComponent.js?vue&type=script&lang=js&external"
export * from "./AgriculturalObjectiveTabComponent.js?vue&type=script&lang=js&external"
import style0 from "./AgriculturalObjectiveTabComponent.vue?vue&type=style&index=0&id=78e5d3f4&prod&scoped=true&lang=scss"
import style1 from "./AgriculturalObjectiveTabComponent.vue?vue&type=style&index=1&id=78e5d3f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e5d3f4",
  null
  
)

export default component.exports